import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "zxStudentExercise/";

// 学生随堂练习 - 按照章获取课程随堂练习总数列表-录播入口
export const classWorkList = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "courseExerciseList", {
    data: _params,
    method: "GET",
  });
};

// 学生随堂练习 - 某章的随堂练习列表查询-分页
export const classWorkMypage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "myPage", {
    data: _params,
    method: "GET",
  });
};

// 学生随堂练习 - 获取学生当个题目完成详情
export const classWorkView = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "view", {
    data: _params,
    method: "GET",
  });
};
// 学生随堂练习 - 获取题目详情
export const classWorkViewQuestionBank = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "viewQuestionBank", {
    data: _params,
    method: "GET",
  });
};

// 学生随堂练习 - 批量保存
export const classWorkSaveBatch = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "saveBatch", {
    data: _params,
    method: "POST",
  });
};
// 学生随堂练习 - 批量提交
export const classWorkSubmitBatch = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "submitBatch", {
    data: _params,
    method: "POST",
  });
};

// 学生随堂练习 - 答题卡
export const classWorkNswerSheet = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "answerSheet", {
    data: _params,
    method: "GET",
  });
};
// 学生随堂练习 - 获取重做次数
export const classWorkRedoNum = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "redoNum", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};
// 学生随堂练习 - 重做（全局参数控制重做次数）
export const classWorkRedo = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "redo", {
    data: _params,
    method: "POST",
  });
};
// 学生随堂练习 - 我的错题集
export const classWorkErrorSet = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "errorSet", {
    data: _params,
    method: "GET",
  });
};
// 学生随堂练习 - 根据章查看所有题目详情（含答案和解析）
export const classWorkQuestionBankList = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "studentAnswerList", {
    data: _params,
    method: "GET",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/classWork.js